import { cn } from '../../utils/helpers';

interface SegmentedOption<T extends string> {
  value: T;
  label: string;
}

interface SegmentedProps<T extends string> {
  value: T;
  options: SegmentedOption<T>[];
  onChange: (value: T) => void;
  className?: string;
}

/** A compact segmented control (radio group) for small, mutually-exclusive choices. */
export default function Segmented<T extends string>({ value, options, onChange, className }: SegmentedProps<T>) {
  return (
    <div className={cn('inline-flex rounded-xl bg-neutral-100 dark:bg-neutral-800 p-1', className)} role="radiogroup">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="radio"
          aria-checked={value === opt.value}
          onClick={() => onChange(opt.value)}
          className={cn(
            'px-3.5 py-1.5 rounded-lg text-sm font-medium transition-all',
            value === opt.value
              ? 'bg-white dark:bg-neutral-700 text-neutral-900 dark:text-neutral-50 shadow-sm dark:shadow-none'
              : 'text-neutral-500 dark:text-neutral-400 hover:text-neutral-800 dark:hover:text-neutral-200',
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
